export const timezonesByCountry = {
    US: [
        { name: 'Eastern Time (ET)', value: 'America/New_York' },
        { name: 'Central Time (CT)', value: 'America/Chicago' },
        { name: 'Mountain Time (MT)', value: 'America/Denver' },
        { name: 'Pacific Time (PT)', value: 'America/Los_Angeles' },
        { name: 'Alaska Time (AKT)', value: 'America/Anchorage' },
        { name: 'Hawaii Time (HST)', value: 'Pacific/Honolulu' },
        { name: 'Arizona Time (no DST)', value: 'America/Phoenix' },
        { name: 'Aleutian Islands Time', value: 'America/Adak' },
    ],
    CA: [
        {
            name: 'Newfoundland Time (NT)',
            value: 'America/St_Johns', // Newfoundland & Labrador (half-hour offset)
        },
        {
            name: 'Atlantic Time (AT)',
            value: 'America/Halifax', // NS, NB, PEI, parts of Labrador
        },
        {
            name: 'Eastern Time (ET)',
            value: 'America/Toronto', // ON, QC
        },
        {
            name: 'Central Time (CT)',
            value: 'America/Winnipeg', // MB, parts of ON, SK (except Regina/Swift Current)
        },
        {
            name: 'Mountain Time (MT)',
            value: 'America/Edmonton', // AB, NT, parts of SK, BC
        },
        {
            name: 'Pacific Time (PT)',
            value: 'America/Vancouver', // BC, Yukon
        },
    ],
};
export const getRelativeTimezones = (country) => {
    if (country !== 'US' && country !== 'CA') {
        return [];
    }
    return timezonesByCountry[country];
};
export const allowedTimezoneIds = Object.values(timezonesByCountry).flatMap((timezone) => timezone.map((timezone) => timezone.value));
export const allowedTimezones = Object.values(timezonesByCountry)
    .flat()
    .reduce((acc, { name, value }) => {
    acc[value] = name;
    return acc;
}, {});
export const intlTimezoneToRelativeTimezoneMap = {
    //
    // 🇺🇸 United States
    //
    // Eastern → America/New_York
    'America/New_York': 'America/New_York',
    'America/Detroit': 'America/New_York',
    'America/Kentucky/Louisville': 'America/New_York',
    'America/Kentucky/Monticello': 'America/New_York',
    'America/Indiana/Indianapolis': 'America/New_York',
    'America/Indiana/Vincennes': 'America/New_York',
    'America/Indiana/Winamac': 'America/New_York',
    'America/Indiana/Marengo': 'America/New_York',
    'America/Indiana/Petersburg': 'America/New_York',
    'America/Indiana/Vevay': 'America/New_York',
    // Central → America/Chicago
    'America/Chicago': 'America/Chicago',
    'America/Indiana/Tell_City': 'America/Chicago',
    'America/Indiana/Knox': 'America/Chicago',
    'America/Menominee': 'America/Chicago',
    'America/North_Dakota/Center': 'America/Chicago',
    'America/North_Dakota/New_Salem': 'America/Chicago',
    'America/North_Dakota/Beulah': 'America/Chicago',
    // Mountain → America/Denver
    'America/Denver': 'America/Denver',
    'America/Boise': 'America/Denver',
    // Arizona (no DST)
    'America/Phoenix': 'America/Phoenix',
    // Pacific → America/Los_Angeles
    'America/Los_Angeles': 'America/Los_Angeles',
    // Alaska → America/Anchorage
    'America/Anchorage': 'America/Anchorage',
    'America/Juneau': 'America/Anchorage',
    'America/Sitka': 'America/Anchorage',
    'America/Metlakatla': 'America/Anchorage',
    'America/Yakutat': 'America/Anchorage',
    'America/Nome': 'America/Anchorage',
    // Aleutian Islands → America/Adak
    'America/Adak': 'America/Adak',
    // Hawaii → Pacific/Honolulu
    'Pacific/Honolulu': 'Pacific/Honolulu',
    //
    // 🇨🇦 Canada
    //
    // Newfoundland → America/St_Johns
    'America/St_Johns': 'America/St_Johns',
    // Atlantic → America/Halifax
    'America/Halifax': 'America/Halifax',
    'America/Glace_Bay': 'America/Halifax',
    'America/Moncton': 'America/Halifax',
    'America/Goose_Bay': 'America/Halifax',
    // Eastern → America/Toronto
    'America/Toronto': 'America/Toronto',
    'America/Montreal': 'America/Toronto',
    'America/Iqaluit': 'America/Toronto',
    'America/Nipigon': 'America/Toronto',
    'America/Thunder_Bay': 'America/Toronto',
    'America/Pangnirtung': 'America/Toronto',
    // Central → America/Winnipeg
    'America/Winnipeg': 'America/Winnipeg',
    'America/Resolute': 'America/Winnipeg',
    'America/Rankin_Inlet': 'America/Winnipeg',
    'America/Rainy_River': 'America/Winnipeg',
    'America/Regina': 'America/Winnipeg', // SK mostly CST year-round
    'America/Swift_Current': 'America/Winnipeg', // SK mostly CST year-round
    // Mountain → America/Edmonton
    'America/Edmonton': 'America/Edmonton',
    'America/Cambridge_Bay': 'America/Edmonton',
    'America/Yellowknife': 'America/Edmonton',
    'America/Inuvik': 'America/Edmonton',
    'America/Dawson_Creek': 'America/Edmonton',
    'America/Fort_Nelson': 'America/Edmonton',
    // Pacific → America/Vancouver
    'America/Vancouver': 'America/Vancouver',
    'America/Whitehorse': 'America/Vancouver',
    'America/Dawson': 'America/Vancouver',
};
//# sourceMappingURL=timezones-by-country.js.map